import classNames from 'classnames'

import { MediaItemComponent, MediaVideoProps } from './types'

const Video: MediaItemComponent<MediaVideoProps> = ({
  className,
  ...props
}) => (
  <video
    className={classNames('object-center object-cover', className)}
    loop
    autoPlay
    muted
    playsInline
    controls={false}
    {...props}
  />
)

Video.mediaType = 'video'

export default Video
